export enum EFreeCollectOutcome {
  COLLECTED = 'collected',
  SKIPPED = 'skipped',
}

export type FreeCollectResult<T> =
  | { outcome: EFreeCollectOutcome.COLLECTED; response: T }
  | { outcome: EFreeCollectOutcome.SKIPPED };

export interface IUseFreeCollectThrottleReturn {
  runThrottledCollect: <T>(
    offerId: string,
    performCollect: () => Promise<T>,
  ) => Promise<FreeCollectResult<T>>;
}
